/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'
import { Modal, Spinner } from 'react-bootstrap'
import { defaultAddClientData, AddClientData } from './IAppModels'
import { StepperComponent } from '../../../assets/ts/components'
import { KTSVG } from '../../../helpers'
import { Step1 } from './steps/Step1'
import { Step2 } from './steps/Step2'
import { Step3 } from './steps/Step3'
import { Step4 } from './steps/Step4'
import crossSymbol from '../../../images/closeSymbol.svg'
import Arrow from '../../../images/arr002.svg'
import SVG from 'react-inlinesvg'
import { useMutation, useLazyQuery } from '@apollo/client'
import {
  GETCLIENTBYID,
  GETLANGUAGE,
  S3_FILE_DELETE,
  UPDATECLIENT,
} from '../../../../utils/GraphQLAPI'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { BUCKET_NAME } from '../../../../utils/config'
import { Step6 } from './steps/Step6'
import { Step5 } from './steps/Step5'
import { lang } from 'moment'
import { Step7 } from './steps/Step7'
const MySwal = withReactContent(Swal)

const style = { positionStyle: 'relative' }

const defaultDialInNumber = [{ dialInNumber: '', position: 0, dialInNoError: '' }]
const modalsRoot = document.getElementById('root-modals') || document.body

const CreateEditAppModal = ({
  show,
  add,
  data1,
  handleClose,
  getTpvAdminClientList,
  image,
  refreshList,
}: any) => {
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [data, setData] = useState<AddClientData>(defaultAddClientData)
  const [hasError, setHasError] = useState(false)
  const [brandsInfo, setBrandsInfo] = useState<any>()
  const [dialNumbers, setDialNumbers] = useState<any>([])
  const [brandsInfoState, setBrandsInfoState] = useState<boolean>(true)
  const [isDisabled, setIsDisabled] = useState<boolean>(false)
  // const [type, setType] = useState<'Add' | 'Edit'>()
  const [updatedData, setUpdatedData] = useState<any>([])
  const [showEditModal, setShowEditModal] = useState<any>('')
  const [imageURL, setImageURL] = useState<any>('')
  const [dataLoaded, setDataLoader] = useState<any>(true)
  const [emailValidate, setEmailValidate] = useState<string>('')
  const [originalEmail, setOriginalEmail] = useState(
    data.clientInfo?.clientAdmin?.clientEmail || ''
  )

  const [notes, setNotes] = useState([
    {
      description: '',
      position: 1,
    },
    {
      description: '',
      position: 2,
    },
    {
      description: '',
      position: 3,
    },
  ])
  // const [checkbrandInfo, setCheckbrandInfo] = useState<boolean>(false)
  const [emailDisabled, setEmailDisabled] = useState<boolean>(false)
  const [dialInNoValidation, setDialInNoValidation] = useState<string>('')
  const [dialInNumber, setdialInNumber] = useState(defaultDialInNumber)
  const [deleteCall, setDeleteCall] = useState<boolean>(false)
  const [apiDialInData, setapiDialInData] = useState([])
  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }
  useEffect(() => {
    setEmailDisabled(false)
    if (dialInNoValidation && dialInNoValidation != '') {
      setEmailDisabled(true)
    }
  }, [dialInNoValidation])
  useEffect(() => { }, [])
  useEffect(() => {
    if (show && data1 !== undefined) {
      getAllLanguages()
    }
    setIsDisabled(true)
    // setType('Edit')
  }, [data1, add, imageURL, dataLoaded, show])

  const [getAllLanguages, { data: language }] = useLazyQuery(GETLANGUAGE, {
    onCompleted: (data) => {
      getCLientById()
    },
  })

  const [getCLientById] = useLazyQuery(GETCLIENTBYID, {
    fetchPolicy: 'network-only',
    variables: {
      id: data1,
    },
    onCompleted: async (data1) => {
      const apiData = data1.getTpvAdminClientById
      setUpdatedData(apiData)

      const brandsInfo: any = []
      const dialNumbers: any = []
      let englishLiveAgentDataOutbound = {
        languageId: language?.getAllLanguages.filter(
          (language: any) => language.languageName === 'English'
        )[0]?.id,
        liveAgentDialInNumber: '',
        vendorId: '',
      }
      let spanishLiveAgentDataOutbound = {
        languageId: language?.getAllLanguages.filter(
          (language: any) => language.languageName === 'Spanish'
        )[0]?.id,
        liveAgentDialInNumber: '',
        vendorId: '',
      }
      setNotes(apiData.clientNotes)
      if (apiData.enableOutBoundLiveAgent) {
        englishLiveAgentDataOutbound = apiData?.clientLiveAgentNumber
          .filter((agent: any) => agent.isOutBound === true)
          .filter((agent: any) => agent.language.languageName === 'English')
          .map((outboundData: any) => ({
            vendorId: outboundData.vendorId,
            liveAgentDialInNumber: outboundData.liveAgentDialInNumber,
            languageId: outboundData.languageId,
          }))[0]
        spanishLiveAgentDataOutbound = apiData?.clientLiveAgentNumber
          .filter((agent: any) => agent.isOutBound === true)
          .filter((agent: any) => agent.language.languageName === 'Spanish')
          .map((outboundData: any) => ({
            vendorId: outboundData.vendorId,
            liveAgentDialInNumber: outboundData.liveAgentDialInNumber,
            languageId: outboundData.languageId,
          }))[0]
      }
      const outboundNumbers = apiData.clientLiveAgentNumber.filter((data: any) => data.isOutBound)
      if (apiData?.brands?.length > 0) {
        for (let index = 0; index < apiData.brands.length; index++) {
          const json: any = {}
          json.name = apiData.brands[index].name
          json.id = apiData.brands[index].id
          json.brandAdmin = apiData.brands[index].brandAdmin
          brandsInfo.push(json)
        }
      }
      // else {
      //   brandsInfo.push({
      //     name: '',
      //     brandAdmin: [],
      //     emailError: '',
      //     brandError: '',
      //     disable: 'false',
      //   })
      // }

      if (apiData.clientDialInNumbers.length > 0) {
        for (let index = 0; index < apiData.clientDialInNumbers.length; index++) {
          const json: any = {}
          json.dialInNumber = apiData.clientDialInNumbers[index].dialInNumber
          json.id = apiData.clientDialInNumbers[index].id
          json.position = apiData.clientDialInNumbers[index].position
          dialNumbers.push(json)
        }
      } else {
        dialNumbers.push({
          dialInNumber: '',
          position: 0,
          dialInNoError: '',
        })
      }
      setdialInNumber(dialNumbers)
      setOriginalEmail(apiData.clientAdmin?.emailId)
      setData(() => {
        let englishLiveAgentData = apiData?.clientLiveAgentNumber
          .filter((agent: any) => agent.isOutBound === false)
          .filter((agent: any) => agent.language.languageName === 'English')[0]
        let spanishLiveAgentData = apiData?.clientLiveAgentNumber
          .filter((agent: any) => agent.isOutBound === false)
          .filter((agent: any) => agent.language.languageName === 'Spanish')[0]
        setapiDialInData(apiData.clientDialInNumbers.map((data: any) => data.dialInNumber))
        return {
          clientInfo: {
            imageUrl: apiData.logoUrl,
            clientName: apiData.name,
            clientAdmin: {
              clientEmail: apiData.clientAdmin?.emailId,
            },
            clientAddress: apiData.address,
            country: apiData.country,
            city: apiData.city,
            state: apiData.state,
            zipcode: apiData.zipCode,
            clientDuns: apiData.clientDunsNumber ? apiData.clientDunsNumber : '',
            EDIRecordingSync: apiData.isEdiRecordingSyncRequired,
            isEdiEnrollmentRequired: apiData.isEdiEnrollmentRequired,
            isCopyUan: apiData.isCopyUan,
            dialInNumber: dialNumbers,
          },
          brandInfo: brandsInfo,
          pricingSetup: {
            setupFees: apiData.setupFees || 0,
            monthlyFees: apiData.monthlyFees || 0,
            perMin: apiData.perMin || 0,
            perTpv: apiData.perTpv || 0,
            monthlyMin: apiData.monthlyMinimums || 0,
            lateChargeFees: apiData.lateChargeFees || 0,
            salesTax: apiData.salesTax || 0,
            stripeFees: apiData.stripeFees || 0,
            creditType: apiData.creditType,
            creditAmount: apiData.creditAmount || 0,
          },
          notesInfo: { inputText: apiData.notes },
          clientSettings: {
            googleSearch: apiData.isGoogleSearchAheadRequired,
            billImages: apiData.isBillImagesRequired,
            transcribedResponse: apiData.isTranscribedResponseRequired,
            isSmartDocEnabled: apiData.isSmartDocEnabled,
            isDncScrubbingEnabled:apiData.isDncScrubbingEnabled,
            liveAgents: apiData.enableLiveAgent,
            liveAgentCustomerDetailsEditable: apiData.enableCustomerDetails,
            smsTPV: apiData.enableTextTpv,
            smsD2D: apiData.enableSmsDocumentVerification,
            emailD2D: apiData.enableEmailDocumentVerification,
            outboundLiveAgent: apiData.enableOutBoundLiveAgent,
            enableApiCheck: apiData.enableApiCheck,
            enableDynamicProductCreation: apiData.enableDynamicProductCreation,
            enableContractStartDate: apiData.enableContractStartDate,
            isUtilityMeterNumberRequired: apiData.isUtilityMeterNumberRequired,
            billUploadOnlyByCamera: apiData.billUploadOnlyByCamera,
            disableExistingCustomerEnrollment: apiData.disableExistingCustomerEnrollment,
            enableKaptureCrm: apiData.enableKaptureCrm,
            enableLineTypeIntelligence: apiData.enableLineTypeIntelligence,
            enableNoTPV: apiData.enableNoTPV,
            enableZipCodeInUtility: apiData.enableZipCodeInUtility,
            enableCustomerReportToSalesChannel: apiData.enableCustomerReportToSalesChannel,
            enableContractRequired: apiData?.enableContractRequired,
            enableTelephoneViewForSalesAdmin: apiData.enableTelephoneViewForSalesAdmin,
            enableMultipleUan: apiData.enableMultipleUan,
            enableWelcomeScriptFlow: apiData.enableWelcomeScriptFlow,
          },
          liveAgentNumberEnglish: {
            languageId: englishLiveAgentDataOutbound?.languageId,
            liveAgentDialInNumber: englishLiveAgentData?.liveAgentDialInNumber,
            vendorId: englishLiveAgentData?.vendorId,
            forwardingNumber: englishLiveAgentData?.vendorCallForwardingNumber,
          },
          liveAgentNumberSpanish: {
            languageId: spanishLiveAgentDataOutbound?.languageId,
            liveAgentDialInNumber: spanishLiveAgentData?.liveAgentDialInNumber,
            vendorId: spanishLiveAgentData?.vendorId,
            forwardingNumber: spanishLiveAgentData?.vendorCallForwardingNumber,
          },
          outboundLiveAgentDialInNumberEng: {
            ...englishLiveAgentDataOutbound,
            languageId: englishLiveAgentDataOutbound?.languageId,
          },
          outboundLiveAgentDialInNumberSpn: {
            ...spanishLiveAgentDataOutbound,
            languageId: spanishLiveAgentDataOutbound?.languageId,
          },
          optInMessage: apiData.clientOptInMessage,
          outboundLiveAgentFailMsg: apiData.clientOutBoundMessage,
        }
      })
      setShowEditModal(apiData)
      setTimeout(() => {
        setDataLoader(false)
      }, 2000)
    },
    onError: (err) => console.error('----------error--', err),
  })

  const updateData = (fieldsToUpdate: Partial<AddClientData>) => {
    setData((prev: any) => ({ ...prev, ...fieldsToUpdate }))
  }
  // Validating the client-details
  const checkClientDetails = (): boolean => {
    const zipVal = /^(?!0{5})([0-9]{5}(?:-[0-9]{4})?|[A-Z][0-9][A-Z])$/
    if (
      !data.clientInfo.clientName ||
      !data.clientInfo?.clientAdmin?.clientEmail ||
      !data.clientInfo.clientAddress ||
      !data.clientInfo.city ||
      !data.clientInfo.state ||
      !data.clientInfo.zipcode ||
      !data.clientInfo.clientDuns
    ) {
      return false
    } else if (data.clientInfo.clientName.length > 40) {
      return false
    } else if (!data.clientInfo.zipcode.match(zipVal)) {
      return false
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data.clientInfo?.clientAdmin?.clientEmail)
    ) {
      return false
    } else if (data.clientInfo.clientAddress.length > 130) {
      return false
    }
    return true
  }

  const checkBrandEmailValidation = (addBrandList: any) => {
    if (addBrandList) {
      addBrandList &&
        addBrandList.map((brand: any) => {
          if (
            brand.brandEmailId !== '' &&
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(brand.brandEmailId)
          ) {
            setBrandsInfo(false)
            //throw sentinel;
          } else {
            setBrandsInfoState(true)
          }
        })
    }
  }

  const checkbrandNameValidation = (addBrandList: any) => {
    if (addBrandList) {
      addBrandList &&
        addBrandList.map((brand: any) => {
          if (/[^a-zA-Z0-9_ ]/.test(brand.brandName)) {
            setBrandsInfoState(false)
            //throw sentinel;
          } else if (brand.brandName.length > 0 && brand.brandName.length > 20) {
            setBrandsInfoState(false)
          } else {
            setBrandsInfoState(true)
          }
        })
    }
  }

  const brandInfoUpdate = (data: boolean, addBrandList: any) => {
    const dataCheckVal: any = checkBrandEmailValidation(addBrandList)
    const brandNameCheckVal: any = checkbrandNameValidation(addBrandList)
    if (dataCheckVal || brandNameCheckVal) {
      setBrandsInfoState(true)
    }
  }

  const checkpriceSetup = () => {
    const setupFees: any = data.pricingSetup.setupFees
    const monthlyFees: any = data.pricingSetup.monthlyFees
    const perMin: any = data.pricingSetup.perMin
    const perTpv: any = data.pricingSetup.perTpv
    const monthlyMin: any = data.pricingSetup.monthlyMin
    const lateChargeFees: any = data.pricingSetup.lateChargeFees
    const salesTax: any = data.pricingSetup.salesTax
    const stripeFees: any = data.pricingSetup.stripeFees
    const creditAmount: any = data.pricingSetup.creditAmount

    if (
      (setupFees && setupFees < 0) ||
      (monthlyFees && monthlyFees < 0) ||
      (perMin && perMin < 0) ||
      (perTpv && perTpv < 0) ||
      (monthlyMin && monthlyMin < 0) ||
      (lateChargeFees && lateChargeFees < 0) ||
      (salesTax && salesTax < 0) ||
      (stripeFees && stripeFees < 0)
    ) {
      setHasError(true)
      return false
    } else {
      setHasError(false)
      return true
    }
  }

  const prevStep = () => {
    if (!stepper.current) {
      return
    }

    stepper.current.goPrev()
  }

  const nextStep = () => {
    setHasError(false)
    if (!stepper.current) {
      return
    }

    if (stepper.current.getCurrentStepIndex() === 1) {
      if (!checkClientDetails()) {
        setHasError(true)
        return
      } else {
        setHasError(false)
      }
    }

    if (stepper.current.getCurrentStepIndex() === 2) {
      if (!brandsInfoState) {
        setHasError(true)
        return
      } else {
        setHasError(false)
      }
    }

    if (stepper.current.getCurrentStepIndex() === 3) {
      if (!checkpriceSetup()) {
        setHasError(true)
        return hasError
      } else {
        setHasError(false)
      }
    }
    stepper.current.goNext()
  }

  // Delete Profile
  const [deleteProfilePicture] = useLazyQuery(S3_FILE_DELETE, {
    fetchPolicy: 'network-only',
    //  variables: {
    //     key: data?.clientInfo?.imageUrl,
    //     bucketName: BUCKET_NAME
    //   },
    onCompleted: () => {
      setDeleteCall(false)
    },
  })

  const [updateClient] = useMutation(UPDATECLIENT, {
    variables: {
      updateClientInput: {
        name: data.clientInfo.clientName,
        logoUrl: deleteCall ? null : data.clientInfo.imageUrl,
        address: data.clientInfo.clientAddress,
        zipCode: data.clientInfo.zipcode,
        clientAdmin: {
          emailId: data.clientInfo?.clientAdmin?.clientEmail,
          id: updatedData?.clientAdmin?.id,
        },
        state: data.clientInfo.state,
        id: updatedData?.id,
        brands: brandsInfo,
        clientDialInNumbers: dialNumbers,
        city: data.clientInfo.city,
        country: data.clientInfo.country,
        clientDunsNumber: data.clientInfo.clientDuns,
        isEdiRecordingSyncRequired: data.clientInfo.EDIRecordingSync,
        isEdiEnrollmentRequired: data.clientInfo.isEdiEnrollmentRequired,
        isCopyUan: data.clientInfo.isCopyUan,
        creditType: data.pricingSetup.creditType,
        creditAmount: Number(data.pricingSetup.creditAmount),
        lateChargeFees: Number(data.pricingSetup.lateChargeFees),
        monthlyFees: Number(data.pricingSetup.monthlyFees),
        monthlyMinimums: Number(data.pricingSetup.monthlyMin),
        salesTax: Number(data.pricingSetup.salesTax),
        setupFees: Number(data.pricingSetup.setupFees),
        stripeFees: Number(data.pricingSetup.stripeFees),
        perMin: Number(data.pricingSetup.perMin),
        perTpv: Number(data.pricingSetup.perTpv),
        isDncScrubbingEnabled:data.clientSettings.isDncScrubbingEnabled,
        notes: data.notesInfo.inputText,
        ...(data.clientSettings.googleSearch !== updatedData.isGoogleSearchAheadRequired && {
          isGoogleSearchAheadRequired: data.clientSettings.googleSearch,
        }),
        ...(data.clientSettings.transcribedResponse !==
          updatedData.isTranscribedResponseRequired && {
          isTranscribedResponseRequired: data.clientSettings.transcribedResponse,
        }),
        ...(data.clientSettings.isSmartDocEnabled !== updatedData.isSmartDocEnabled && {
          isSmartDocEnabled: data.clientSettings.isSmartDocEnabled,
        }),
        ...(data.clientSettings.billImages !== updatedData.isBillImagesRequired && {
          isBillImagesRequired: data.clientSettings.billImages,
        }),
        ...(data.clientSettings.liveAgentCustomerDetailsEditable !==
          updatedData.enableCustomerDetails && {
          enableCustomerDetails: data.clientSettings.liveAgentCustomerDetailsEditable,
        }),
        ...(data.clientSettings.smsTPV !== updatedData.enableTextTpv && {
          enableTextTpv: data.clientSettings.smsTPV,
        }),
        ...(data.clientSettings.smsD2D !== updatedData.enableSmsDocumentVerification && {
          enableSmsDocumentVerification: data.clientSettings.smsD2D,
        }),
        ...(data.clientSettings.emailD2D !== updatedData.enableEmailDocumentVerification && {
          enableEmailDocumentVerification: data.clientSettings.emailD2D,
        }),
        ...(data.clientSettings.enableContractRequired !== updatedData.enableContractRequired && {
          enableContractRequired: data.clientSettings.enableContractRequired,
        }),

        ...(data.clientSettings.enableApiCheck !== updatedData.enableApiCheck && {
          enableApiCheck: data.clientSettings.enableApiCheck,
        }),
        ...(data.clientSettings.enableDynamicProductCreation !==
          updatedData.enableDynamicProductCreation && {
          enableDynamicProductCreation: data.clientSettings.enableDynamicProductCreation,
        }),
        ...(data.clientSettings.enableContractStartDate !== updatedData.enableContractStartDate && {
          enableContractStartDate: data.clientSettings.enableContractStartDate,
        }),
        ...(data.clientSettings.isUtilityMeterNumberRequired !==
          updatedData.isUtilityMeterNumberRequired && {
          isUtilityMeterNumberRequired: data.clientSettings.isUtilityMeterNumberRequired,
        }),
        ...(data.clientSettings.billUploadOnlyByCamera !== updatedData.billUploadOnlyByCamera && {
          billUploadOnlyByCamera: data.clientSettings.billUploadOnlyByCamera,
        }),
        ...(data.clientSettings.disableExistingCustomerEnrollment !==
          updatedData.disableExistingCustomerEnrollment && {
          disableExistingCustomerEnrollment: data.clientSettings.disableExistingCustomerEnrollment,
        }),
        ...(data.clientSettings.enableKaptureCrm !== updatedData.enableKaptureCrm && {
          enableKaptureCrm: data.clientSettings.enableKaptureCrm,
        }),
        enableLineTypeIntelligence: data.clientSettings.enableLineTypeIntelligence,
        ...(data.clientSettings.enableNoTPV !== updatedData.enableNoTPV && {
          enableNoTPV: data.clientSettings.enableNoTPV,
        }),
        ...(data.clientSettings.enableZipCodeInUtility !== updatedData.enableZipCodeInUtility && {
          enableZipCodeInUtility: data.clientSettings.enableZipCodeInUtility,
        }),
        ...(data.clientSettings.enableCustomerReportToSalesChannel !==
          updatedData.enableCustomerReportToSalesChannel && {
          enableCustomerReportToSalesChannel:
            data.clientSettings.enableCustomerReportToSalesChannel,
        }),
        ...(data.clientSettings.liveAgents !== updatedData.enableLiveAgent && {
          enableLiveAgent: data.clientSettings.liveAgents,
        }),
        ...(data.clientSettings.outboundLiveAgent !== updatedData.enableOutBoundLiveAgent && {
          enableOutBoundLiveAgent: data.clientSettings.outboundLiveAgent,
        }),
        ...(data.clientSettings.enableTelephoneViewForSalesAdmin !== updatedData.enableTelephoneViewForSalesAdmin && {
          enableTelephoneViewForSalesAdmin: data.clientSettings.enableTelephoneViewForSalesAdmin,
        }),
        ...(data.clientSettings.enableMultipleUan !== updatedData.enableMultipleUan && {
          enableMultipleUan: data.clientSettings.enableMultipleUan,
        }),
        enableWelcomeScriptFlow: data.clientSettings.enableWelcomeScriptFlow,
        isSmartDocEnabled: data.clientSettings.isSmartDocEnabled,
        clientNotes: notes?.map((note: any) => {
          delete note.__typename
          return note
        }),
        ClientLiveAgentNumber: data.clientSettings.liveAgents
          ? [data.liveAgentNumberEnglish, data.liveAgentNumberSpanish]
          : null,
        clientOptInMessage: Boolean(data?.optInMessage) ? data.optInMessage : null,
        clientOutBoundNumbers: Boolean(
          data?.outboundLiveAgentDialInNumberEng?.liveAgentDialInNumber
        )
          ? [data?.outboundLiveAgentDialInNumberEng, data?.outboundLiveAgentDialInNumberSpn]
          : null,
        clientOutBoundMessage: data?.outboundLiveAgentFailMsg,
      },
    },
    onCompleted: async (data) => {
      if (data.updateClient.id) {
        if (deleteCall) {
          ; (async () => {
            const response = await deleteProfilePicture({
              variables: {
                key: updatedData?.logoUrl,
                bucketName: BUCKET_NAME,
              },
            })
            if (response) {
              setDeleteCall(false)
            }
          })()
        }

        const options: any = {
          customClass: {
            popup: 'swal2-border-radius',
          },
          title: 'Client updated successfully',
          icon: 'success',
          confirmButtonColor: '#3E97FF',
        }
        MySwal.fire(options)
        handleDataAfterClose()
        setHasError(false)
      } else {
        MySwal.fire({
          icon: 'error',
          title: 'Error in Updating Client',
        })
      }
      refreshList()
      //getTpvAdminClientList();
    },
    onError: (error) => {
      MySwal.fire({
        icon: 'error',
        title: error.message,
      })
    },
  })

  const validateDialInNumber = (brandAdmindata: any) => {
    let valid = false
    brandAdmindata.forEach((element: any) => {
      valid = Object.values(element).some((v: any) => v)
    })
    return valid
  }

  const submit = async (e: any) => {
    const filterBrandsInfo = (data: any) => {
      return data.filter((brand: any) => {
        // Remove the brand if it has isDelete set to true and no id
        if (brand.isDelete && !brand.hasOwnProperty('id')) {
          return false
        }
        // Filter the brandAdmin array
        brand.brandAdmin = brand.brandAdmin.filter((admin: any) => {
          // Remove brandAdmin if it has isDelete set to true and no id
          return !(admin.isDelete && !admin.hasOwnProperty('id')) && admin.emailId !== ''
        })
        // Remove brand if it has no brandAdmin left after filtering
        return brand.brandAdmin.length > 0
        // return true
      })
    }

    const filteredBrandsInfo = filterBrandsInfo(brandsInfo)
    setBrandsInfo(filteredBrandsInfo)

    if (data?.clientInfo?.dialInNumber) {
      const values = [...dialInNumber]

      const isEmptyObj = (obj: {
        dialInNumber: string
        position?: number
        dialInNoError?: string
      }) => {
        return Object.values(obj.dialInNumber).every(
          (val) => val === '' || val === null || val === undefined
        )
      }

      const index = data?.clientInfo?.dialInNumber?.findIndex((obj) => isEmptyObj(obj))

      if (index > -1) {
        values[index]['dialInNoError'] = 'Dial In Number is required'
        setHasError(true)
        return
      }
    }
    if (
      data?.clientSettings.liveAgents &&
      (Object.values(data?.liveAgentNumberEnglish).includes('') ||
        Object.values(data?.liveAgentNumberSpanish).includes('') ||
        data?.liveAgentNumberEnglish?.liveAgentDialInNumber?.length !== 10 ||
        data?.liveAgentNumberSpanish?.liveAgentDialInNumber?.length !== 10)
    ) {
      setHasError(true)
      return
    }

    setTimeout(() => {
      updateClient()
    }, 0)
    // if (apiError) {
    // await handleDataAfterClose()
    // }
  }

  useEffect(() => {
    const numbers = []
    const numberData: any = data.clientInfo.dialInNumber

    if (numberData.length >= 1 && validateDialInNumber(numberData)) {
      for (let index = 0; index < numberData.length; index++) {
        const number_json: any = {}
        const brandSplitedEmail = numberData[index].dialInNumber

        if (brandSplitedEmail !== '') {
          number_json.dialInNumber = numberData[index].dialInNumber
          number_json.id = numberData[index].id
          number_json.position = numberData[index].position
          // if (numberData[index].id) {
          //   number_json.brandAdmin = {
          //     ...number_json.brandAdmin,
          //     id: numberData[index].brandAdminId,
          //   }
          // }
          if (numberData[index].isDelete) {
            number_json.isDelete = numberData[index].isDelete
          }
          numbers.push(number_json)
        }
      }
    }
    setDialNumbers(numbers)
  }, [data.clientInfo.dialInNumber])

  const handleDataAfterClose = async () => {
    setShowEditModal({ logoUrl: '' })
    setData(defaultAddClientData)
    setImageURL('')
    handleClose()
    setdialInNumber(defaultDialInNumber)
    setEmailValidate('')
    setEmailDisabled(false)
  }
  return (
    <>
      {showEditModal &&
        showEditModal.clientAdmin?.emailId &&
        createPortal(
          <Modal
            id='kt_modal_create_app'
            tabIndex={-1}
            aria-hidden='true'
            dialogClassName='modal-dialog modal-dialog-centered modal-fullscreen'
            show={show}
            onHide={handleDataAfterClose}
            onEntered={loadStepper}
            backdrop={true}
            className='custom-border w-880px'
          >
            <div className='modal-content' style={{ borderRadius: '14px' }}>
              <div className='modal-header' style={{ height: '80px' }}>
                <h2>{add} Client</h2>
                {/* begin::Close */}
                <div
                  className='btn btn-sm btn-icon btn-active-color-primary'
                  onClick={() => handleDataAfterClose()}
                >
                  <img src={crossSymbol} alt='close' />
                </div>
                {/* end::Close */}
              </div>

              <div className='modal-body py-lg-10 px-lg-10'>
                {/*begin::Stepper */}
                <div
                  ref={stepperRef}
                  className='stepper stepper-pills stepper-column d-flex flex-xs-column flex-row flex-xl-row flex-row-fluid'
                  id='kt_modal_create_app_stepper'
                >
                  {/* begin::Aside*/}
                  <div className='d-flex justify-content-center justify-content-xl-start flex-row-auto w-300px w-xl-300px'>
                    {/* begin::Nav*/}
                    <div className='stepper-nav ps-lg-10 justify-content-sm-between'>
                      {/* begin::Step 1*/}
                      <div className='stepper-item current' data-kt-stepper-element='nav'>
                        {/* begin::Wrapper*/}
                        <div className='stepper-wrapper w-30'>
                          {/* begin::Icon*/}
                          <div className='stepper-icon w-40px h-40px'>
                            <i className='stepper-check fas fa-check'></i>
                            <span className='stepper-number'>1</span>
                          </div>
                          {/* end::Icon*/}

                          {/* begin::Label*/}
                          <div className='stepper-label'>
                            <span
                              className='stepper-title fw-500'
                              style={{
                                color: '#5E6278',
                                fontSize: '15px',
                                fontStyle: 'normal',
                                lineHeight: '24px',
                              }}
                            >
                              Client Info
                            </span>

                            <div
                              className='stepper-desc text-muted'
                              style={{ fontSize: '12px', lineHeight: '18px' }}
                            >
                              Provide client information
                            </div>
                          </div>
                          {/* end::Label*/}
                        </div>
                        {/* end::Wrapper*/}

                        {/* begin::Line*/}
                        <div className='stepper-line h-40px'></div>
                        {/* end::Line*/}
                      </div>
                      {/* end::Step 1*/}

                      {/* begin::Step 2*/}
                      <div className='stepper-item' data-kt-stepper-element='nav'>
                        {/* begin::Wrapper*/}
                        <div className='stepper-wrapper'>
                          {/* begin::Icon*/}
                          <div className='stepper-icon w-40px h-40px'>
                            <i className='stepper-check fas fa-check'></i>
                            <span className='stepper-number'>2</span>
                          </div>
                          {/* begin::Icon*/}

                          {/* begin::Label*/}
                          <div className='stepper-label'>
                            <span
                              className='stepper-title fw-500'
                              style={{ color: '#5E6278', fontSize: '15px', lineHeight: '24px' }}
                            >
                              System Admin Info
                            </span>

                            <div
                              className='stepper-desc text-muted'
                              style={{ fontSize: '12px', lineHeight: '18px' }}
                            >
                              Add system admin and admin info
                            </div>
                          </div>
                          {/* begin::Label*/}
                        </div>
                        {/* end::Wrapper*/}

                        {/* begin::Line*/}
                        <div className='stepper-line h-40px'></div>
                        {/* end::Line*/}
                      </div>
                      {/* end::Step 2*/}

                      {/* begin::Step 3*/}
                      <div className='stepper-item' data-kt-stepper-element='nav'>
                        {/* begin::Wrapper*/}
                        <div className='stepper-wrapper'>
                          {/* begin::Icon*/}
                          <div className='stepper-icon w-40px h-40px'>
                            <i className='stepper-check fas fa-check'></i>
                            <span className='stepper-number'>3</span>
                          </div>
                          {/* end::Icon*/}

                          {/* begin::Label*/}
                          <div className='stepper-label'>
                            <span
                              className='stepper-title fw-500'
                              style={{ color: '#5E6278', fontSize: '15px', lineHeight: '24px' }}
                            >
                              Pricing Setup
                            </span>

                            <div
                              className='stepper-desc text-muted'
                              style={{ fontSize: '12px', lineHeight: '18px' }}
                            >
                              Provide pricing details
                            </div>
                          </div>
                          {/* end::Label*/}
                        </div>
                        {/* end::Wrapper*/}

                        {/* begin::Line*/}
                        <div className='stepper-line h-40px'></div>
                        {/* end::Line*/}
                      </div>
                      {/* end::Step 3*/}

                      {/* begin::Step 4*/}
                      <div className='stepper-item' data-kt-stepper-element='nav'>
                        {/* begin::Wrapper*/}
                        <div className='stepper-wrapper'>
                          {/* begin::Icon*/}
                          <div className='stepper-icon w-40px h-40px'>
                            <i className='stepper-check fas fa-check'></i>
                            <span className='stepper-number'>4</span>
                          </div>
                          {/* end::Icon*/}

                          {/* begin::Label*/}
                          <div className='stepper-label'>
                            <span
                              className='stepper-title fw-500'
                              style={{ color: '#5E6278', fontSize: '15px', lineHeight: '24px' }}
                            >
                              Notes
                            </span>

                            <div
                              className='stepper-desc text-muted'
                              style={{ fontSize: '12px', lineHeight: '18px' }}
                            >
                              Add notes for reference
                            </div>
                          </div>
                          {/* end::Label*/}
                        </div>
                        {/* end::Wrapper*/}

                        {/* begin::Line*/}
                        <div className='stepper-line h-40px'></div>
                        {/* <div className='stepper-line h-40px'></div> */}
                        {/* end::Line*/}
                      </div>

                      <div className='stepper-item' data-kt-stepper-element='nav'>
                        {/* begin::Wrapper*/}
                        <div className='stepper-wrapper'>
                          {/* begin::Icon*/}
                          <div className='stepper-icon w-40px h-40px'>
                            <i className='stepper-check fas fa-check'></i>
                            <span className='stepper-number'>5</span>
                          </div>
                          {/* end::Icon*/}

                          {/* begin::Label*/}
                          <div className='stepper-label'>
                            <span
                              className='stepper-title fw-500'
                              style={{ color: '#5E6278', fontSize: '15px', lineHeight: '24px' }}
                            >
                              Settings
                            </span>

                            <div
                              className='stepper-desc text-muted'
                              style={{ fontSize: '12px', lineHeight: '18px' }}
                            >
                              Enable/Disable features
                            </div>
                          </div>
                        </div>
                        <div className='stepper-line h-40px'></div>
                      </div>
                      <div className='stepper-item' data-kt-stepper-element='nav'>
                        <div className='stepper-wrapper'>
                          <div className='stepper-icon w-40px h-40px'>
                            <i className='stepper-check fas fa-check'></i>
                            <span className='stepper-number'>6</span>
                          </div>

                          <div className='stepper-label'>
                            <span
                              className='stepper-title fw-500'
                              style={{ color: '#5E6278', fontSize: '15px', lineHeight: '24px' }}
                            >
                              Dial In Numbers
                            </span>

                            <div
                              className='stepper-desc text-muted'
                              style={{ fontSize: '12px', lineHeight: '18px' }}
                            >
                              Add dial in numbers for TPV
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* end::Step 4*/}
                    </div>
                    {/* end::Nav*/}
                  </div>
                  {/* begin::Aside*/}

                  {/*begin::Content */}
                  <div className='flex-row-fluid px-lg-8 w-500px'>
                    {/*begin::Form */}
                    {dataLoaded ? (
                      <div className='text-center'>
                        <Spinner animation='border' className='text-gray-600' role='status'>
                          <span className='visually-hidden'>Loading...</span>
                        </Spinner>
                      </div>
                    ) : (
                      <form noValidate id='kt_modal_create_app_form'>
                        <Step1
                          data={data}
                          updateData={updateData}
                          hasError={hasError}
                          isDisabled={isDisabled}
                          style={style}
                          setNotes={setNotes}
                          notes={notes}
                          setEmailDisabled={setEmailDisabled}
                          emailDisabled={emailDisabled}
                          setDialInNoValidation={setDialInNoValidation}
                          emailValidate={emailValidate}
                          setEmailValidate={setEmailValidate}
                          dialInNoValidation={dialInNoValidation}
                          setdialInNumber={setdialInNumber}
                          dialInNumber={dialInNumber}
                          updatedData={updatedData}
                          refreshList={refreshList}
                          setImageURL={setImageURL}
                          setDeleteCall={setDeleteCall}
                          deleteCall={deleteCall}
                          originalEmail={originalEmail}
                        />
                        <Step7
                          data={data}
                          updateData={updateData}
                          hasError={hasError}
                          isDisabled={isDisabled}
                          style={style}
                          callBack={brandInfoUpdate}
                          setBrandsInfo={setBrandsInfo}
                          setEmailDisabled={setEmailDisabled}
                        />
                        <Step3
                          data={data}
                          updateData={updateData}
                          hasError={hasError}
                          isDisabled={isDisabled}
                          style={style}
                        />
                        <Step4
                          data={data}
                          updateData={updateData}
                          hasError={hasError}
                          isDisabled={isDisabled}
                          style={style}
                        />
                        <Step6 data={data} updateData={updateData} />
                        <Step5
                          data={data}
                          updateData={updateData}
                          setDialInNoValidation={setDialInNoValidation}
                          dialInNoValidation={dialInNoValidation}
                          setEmailDisabled={setEmailDisabled}
                          emailDisabled={emailDisabled}
                          setdialInNumber={setdialInNumber}
                          dialInNumber={dialInNumber}
                          apiDialInData={apiDialInData}
                          hasError={hasError}
                        />

                        {/*begin::Actions */}

                        <div className='d-flex flex-stack pt-10'>
                          <div className='me-2'>
                            <button
                              type='button'
                              className='btn btn-lg btn-light-primary me-3'
                              data-kt-stepper-action='previous'
                              data-bs-dismiss='modal'
                              onClick={prevStep}
                            >
                              <span className='me-1'>
                                <SVG src={Arrow} className='mh-50px' />
                              </span>
                              <span>Back</span>
                            </button>
                          </div>
                          <div>
                            <button
                              type='button'
                              className='btn btn-lg btn-primary'
                              data-kt-stepper-action='submit'
                              onClick={(e) => {
                                submit(e)
                              }}
                            >
                              {add === 'Add' ? 'Create Client' : 'Update Client'}
                              <KTSVG
                                path='/media/icons/duotune/arrows/arr064.svg'
                                className='svg-icon-3 ms-2 me-0'
                              />
                            </button>

                            <button
                              type='button'
                              className='btn btn-lg btn-primary'
                              data-kt-stepper-action='next'
                              onClick={nextStep}
                              disabled={emailDisabled}
                            >
                              Continue{' '}
                              <KTSVG
                                path='/media/icons/duotune/arrows/arr064.svg'
                                className='svg-icon-3 ms-1 me-0'
                              />
                            </button>
                          </div>
                        </div>

                        {/*end::Actions */}
                      </form>
                    )}
                    {/*end::Form */}
                  </div>
                  {/*end::Content */}
                </div>
                {/* end::Stepper */}
              </div>
            </div>
          </Modal>,
          modalsRoot
        )}
    </>
  )
}

export { CreateEditAppModal }
